<div class="admin-panel-announcements">
  <h1 class="mb-4">Zarządzanie komunikatami</h1>

  <div class="wide">
    <p-card class="mb-4">
      <div class="w-full flex flex-col gap-5">
        <div class="text-xl font-semibold">Filtrowanie zaawansowane</div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
          <div class="flex flex-col gap-3">
            <span class="font-bold" id="titleFilterLabel">Tytuł</span>
            <input
              (change)="onPrimeFilterChange($event.target, 'title')"
              [(ngModel)]="tableFilters.title"
              aria-labelledby="titleFilterLabel"
              pInputText
            />
          </div>
          <div class="flex flex-col gap-3">
            <span class="font-bold" id="confirmationFilterLabel"
              >Wymaga potwierdzenia</span
            >
            <p-select
              (onChange)="
                onPrimeFilterChange($event.value, 'requiresConfirmation')
              "
              [(ngModel)]="tableFilters.requiresConfirmation"
              [options]="confirmationOptions"
              [showClear]="true"
              placeholder="Wybierz wartość"
              appendTo="body"
              ariaLabelledBy="confirmationFilterLabel"
              class="w-full"
              optionLabel="label"
              optionValue="value"
            ></p-select>
          </div>
          <div class="flex flex-col gap-3">
            <span class="font-bold" id="requestCodeFilterLabel"
              >Kod wniosku</span
            >
            <p-select
              (onChange)="onPrimeFilterChange($event.value, 'requestCode')"
              [(ngModel)]="tableFilters.requestCode"
              [options]="requestCodeOptions()"
              [showClear]="true"
              placeholder="Wybierz wartość"
              appendTo="body"
              ariaLabelledBy="requestCodeFilterLabel"
              class="w-full"
              optionLabel="label"
              optionValue="value"
            ></p-select>
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
          <div class="flex flex-col gap-3">
            <span class="font-bold" id="channelFilterLabel">Kanał</span>
            <p-select
              (onChange)="onPrimeFilterChange($event.value, 'channel')"
              [(ngModel)]="tableFilters.channel"
              [options]="channelOptions"
              [showClear]="true"
              placeholder="Wybierz wartość"
              appendTo="body"
              ariaLabelledBy="channelFilterLabel"
              class="w-full"
              optionLabel="label"
              optionValue="value"
            ></p-select>
          </div>
          <div
            class="flex w-full gap-3 justify-start md:w-auto md:gap-2 md:justify-end md:justify-self-end md:col-start-3"
          >
            <p-button
              (click)="clearFilters()"
              label="Wyczyść filtry"
              styleClass="customInfoButton outlined"
              type="button"
            />
            <p-button
              (onClick)="searchAnnouncements($event)"
              label="Wyszukaj"
              styleClass="customInfoButton"
              type="button"
            />
          </div>
        </div>
      </div>
    </p-card>
  </div>

  <div class="wide">
    <p-table
      #table
      (onSort)="onPrimeSortChange($event)"
      [lazy]="true"
      [loading]="isDataLoading()"
      [rows]="tablePage()?.size || 10"
      [scrollable]="true"
      [tableStyle]="{ 'min-width': '90rem' }"
      [totalRecords]="tablePage()?.totalElements || 0"
      [value]="rows()"
      dataKey="id"
      scrollHeight="flex"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="id" class="w-36 min-w-36 max-w-36">
            <div class="flex items-center gap-2">
              Identyfikator
              <p-sortIcon field="id" />
            </div>
          </th>
          <th pSortableColumn="title" class="w-60 min-w-60 max-w-60">
            <div class="flex items-center gap-2">
              Tytuł
              <p-sortIcon field="title" />
            </div>
          </th>
          <th pSortableColumn="status" class="w-56 min-w-56 max-w-56">
            <div class="flex items-center gap-2">
              Status
              <p-sortIcon field="status" />
            </div>
          </th>
          <th pSortableColumn="createdAt" class="w-46 min-w-46 max-w-46">
            <div class="flex items-center gap-2">
              Data utworzenia
              <p-sortIcon field="createdAt" />
            </div>
          </th>
          <th pSortableColumn="startDate" class="w-50 min-w-50 max-w-50">
            <div class="flex items-center gap-2">
              Data rozpoczęcia
              <p-sortIcon field="startDate" />
            </div>
          </th>
          <th pSortableColumn="endDate" class="w-50 min-w-50 max-w-50">
            <div class="flex items-center gap-2">
              Data wygaśnięcia
              <p-sortIcon field="endDate" />
            </div>
          </th>
          <th pSortableColumn="recipientType">
            <div class="flex items-center gap-2">
              Typ adresatów
              <p-sortIcon field="recipientType" />
            </div>
          </th>
          <th pSortableColumn="createdBy">
            <div class="flex items-center gap-2">
              Utworzył
              <p-sortIcon field="createdBy" />
            </div>
          </th>
          <th alignFrozen="right" pFrozenColumn>Akcje</th>
        </tr>
        <tr>
          <td class="table-filter-cell w-36 min-w-36 max-w-36">
            <input
              type="number"
              (change)="onPrimeFilterChange($event.target, 'id')"
              [(ngModel)]="tableFilters.id"
              aria-label="Filtruj po identyfikatorze"
              pInputText
              class="w-full min-w-0"
            />
          </td>
          <td class="table-filter-cell w-60 min-w-60 max-w-60">
            <input
              (change)="onPrimeFilterChange($event.target, 'title')"
              [(ngModel)]="tableFilters.title"
              aria-label="Filtruj po tytule"
              class="w-full"
              pInputText
            />
          </td>
          <td class="table-filter-cell w-56 min-w-56 max-w-56">
            <p-select
              (onChange)="onPrimeFilterChange($event.value, 'status')"
              [(ngModel)]="tableFilters.status"
              [options]="statusOptions"
              [showClear]="true"
              placeholder="Wybierz wartość"
              appendTo="body"
              ariaLabel="Filtruj po statusie"
              class="w-full customDatePicker"
              optionLabel="label"
              optionValue="value"
            ></p-select>
          </td>
          <td class="table-filter-cell w-50 min-w-50 max-w-50">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'createdAt')"
              (onSelect)="onPrimeFilterChange($event, 'createdAt')"
              [(ngModel)]="tableFilters.createdAt"
              [readonlyInput]="true"
              [showClear]="true"
              appendTo="body"
              ariaLabel="Filtruj po dacie utworzenia"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
            />
          </td>
          <td class="table-filter-cell w-50 min-w-50 max-w-50">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'startDate')"
              (onSelect)="onPrimeFilterChange($event, 'startDate')"
              [(ngModel)]="tableFilters.startDate"
              [readonlyInput]="true"
              [showClear]="true"
              appendTo="body"
              ariaLabel="Filtruj po dacie rozpoczęcia"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
            />
          </td>
          <td class="table-filter-cell w-46 min-w-46 max-w-46">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'endDate')"
              (onSelect)="onPrimeFilterChange($event, 'endDate')"
              [(ngModel)]="tableFilters.endDate"
              [readonlyInput]="true"
              [showClear]="true"
              appendTo="body"
              ariaLabel="Filtruj po dacie wygaśnięcia"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
            />
          </td>
          <td class="table-filter-cell">
            <p-select
              (onChange)="onPrimeFilterChange($event.value, 'recipientType')"
              [(ngModel)]="tableFilters.recipientType"
              [options]="recipientTypeOptions"
              [showClear]="true"
              placeholder="Wybierz wartość"
              appendTo="body"
              ariaLabel="Filtruj po typie adresatów"
              class="w-full"
              optionLabel="label"
              optionValue="value"
            ></p-select>
          </td>
          <td class="table-filter-cell">
            <input
              (change)="onPrimeFilterChange($event.target, 'createdBy')"
              [(ngModel)]="tableFilters.createdBy"
              aria-label="Filtruj po użytkowniku"
              pInputText
            />
          </td>
          <td alignFrozen="right" pFrozenColumn></td>
        </tr>
      </ng-template>
      <ng-template #body let-announcement>
        <tr>
          <td class="w-36 min-w-36 max-w-36">{{ announcement.id }}</td>
          <td class="title-cell w-60 min-w-60 max-w-60">
            {{ announcement.title }}
          </td>
          <td class="w-56 min-w-56 max-w-56">
            <span
              [ngClass]="announcement.status | announcementStatusBadgeClass"
            >
              {{ statusLabel(announcement.status) }}
            </span>
          </td>
          <td class="w-46 min-w-46 max-w-46">
            {{ announcement.createdAt | date: 'yyyy-MM-dd HH:mm:ss' }}
          </td>
          <td class="w-50 min-w-50 max-w-50">
            {{
              announcement.startDate
                ? (announcement.startDate | date: 'yyyy-MM-dd HH:mm:ss')
                : '-'
            }}
          </td>
          <td class="w-50 min-w-50 max-w-50">
            {{
              announcement.endDate
                ? (announcement.endDate | date: 'yyyy-MM-dd HH:mm:ss')
                : '-'
            }}
          </td>
          <td>{{ recipientTypeLabel(announcement.recipientType) }}</td>
          <td>{{ announcement.createdBy }}</td>
          <td alignFrozen="right" class="h-16 align-middle" pFrozenColumn>
            <div class="flex items-center h-full justify-end">
              <p-button
                (click)="showDetails(announcement)"
                [rounded]="true"
                [text]="true"
                ariaLabel="Zobacz szczegóły"
                pTooltip="Zobacz szczegóły"
                tooltipPosition="top"
                type="button"
              >
                <i aria-hidden="true" class="pi pi-eye icon"></i>
              </p-button>
              @if (announcement | isAnnouncementDeleteAvailable) {
                <p-button
                  (click)="openDeleteAnnouncementModal(announcement)"
                  [rounded]="true"
                  [text]="true"
                  ariaLabel="Usuń"
                  pTooltip="Usuń"
                  tooltipPosition="top"
                  type="button"
                >
                  <app-icon [name]="'trash'"></app-icon>
                </p-button>
              }
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="9">Brak danych</td>
        </tr>
      </ng-template>
    </p-table>
    <div
      class="mt-4 flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between"
    >
      <p-button
        (click)="addAnnouncement()"
        [text]="true"
        aria-label="Dodaj komunikat"
        label="Dodaj komunikat"
        styleClass="customInfoButton"
        type="button"
      />
      <div class="flex items-center gap-4">
        <p-paginator
          (onPageChange)="onPrimePageChange($event)"
          [rowsPerPageOptions]="[10, 25, 50]"
          [rows]="tablePage()?.size || 10"
          [totalRecords]="tablePage()?.totalElements || 0"
          class="customPrimePaginator"
          pageLinkSize="3"
        />
        <div class="text-sm">
          <span>
            Strona {{ (tablePage()?.number || 0) + 1 }} z
            {{ tablePage()?.totalPages || 0 }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="narrow">
    <p-card class="mb-4">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="titleFilterMobileLabel">Tytuł</span>
          <input
            (input)="onPrimeFilterChangeMobile($event.target, 'title')"
            [(ngModel)]="tableFilters.title"
            aria-labelledby="titleFilterMobileLabel"
            class="w-full"
            pInputText
          />
        </div>
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="confirmationFilterMobileLabel"
            >Wymaga potwierdzenia</span
          >
          <p-select
            (onChange)="
              onPrimeFilterChangeMobile($event.value, 'requiresConfirmation')
            "
            [(ngModel)]="tableFilters.requiresConfirmation"
            [options]="confirmationOptions"
            [showClear]="true"
            placeholder="Wybierz wartość"
            appendTo="body"
            ariaLabelledBy="confirmationFilterMobileLabel"
            class="w-full"
            optionLabel="label"
            optionValue="value"
          ></p-select>
        </div>
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="requestCodeFilterMobileLabel"
            >Kod wniosku</span
          >
          <p-select
            (onChange)="onPrimeFilterChangeMobile($event.value, 'requestCode')"
            [(ngModel)]="tableFilters.requestCode"
            [options]="requestCodeOptions()"
            [showClear]="true"
            placeholder="Wybierz wartość"
            appendTo="body"
            ariaLabelledBy="requestCodeFilterMobileLabel"
            class="w-full"
            optionLabel="label"
            optionValue="value"
          ></p-select>
        </div>
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="channelFilterMobileLabel">Kanał</span>
          <p-select
            (onChange)="onPrimeFilterChangeMobile($event.value, 'channel')"
            [(ngModel)]="tableFilters.channel"
            [options]="channelOptions"
            [showClear]="true"
            placeholder="Wybierz wartość"
            appendTo="body"
            ariaLabelledBy="channelFilterMobileLabel"
            class="w-full"
            optionLabel="label"
            optionValue="value"
          ></p-select>
        </div>
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="idFilterMobileLabel">Identyfikator</span>
          <input
            type="number"
            (input)="onPrimeFilterChangeMobile($event.target, 'id')"
            [(ngModel)]="tableFilters.id"
            aria-labelledby="idFilterMobileLabel"
            class="w-full"
            pInputText
          />
        </div>
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="statusFilterMobileLabel">Status</span>
          <p-select
            (onChange)="onPrimeFilterChangeMobile($event.value, 'status')"
            [(ngModel)]="tableFilters.status"
            [options]="statusOptions"
            [showClear]="true"
            placeholder="Wybierz wartość"
            appendTo="body"
            ariaLabelledBy="statusFilterMobileLabel"
            class="w-full"
            optionLabel="label"
            optionValue="value"
          ></p-select>
        </div>
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="createdAtFilterMobileLabel"
            >Data utworzenia</span
          >
          <p-date-picker
            (onClear)="onPrimeFilterChangeMobile($event, 'createdAt')"
            (onSelect)="onPrimeFilterChangeMobile($event, 'createdAt')"
            [(ngModel)]="tableFilters.createdAt"
            [iconDisplay]="'input'"
            [readonlyInput]="true"
            [showClear]="true"
            [showIcon]="true"
            appendTo="body"
            ariaLabelledBy="createdAtFilterMobileLabel"
            class="w-full customDatePicker"
            dateFormat="dd-mm-yy"
          />
        </div>
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="startDateFilterMobileLabel"
            >Data rozpoczęcia</span
          >
          <p-date-picker
            (onClear)="onPrimeFilterChangeMobile($event, 'startDate')"
            (onSelect)="onPrimeFilterChangeMobile($event, 'startDate')"
            [(ngModel)]="tableFilters.startDate"
            [iconDisplay]="'input'"
            [readonlyInput]="true"
            [showClear]="true"
            [showIcon]="true"
            appendTo="body"
            ariaLabelledBy="startDateFilterMobileLabel"
            class="w-full customDatePicker"
            dateFormat="dd-mm-yy"
          />
        </div>
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="endDateFilterMobileLabel"
            >Data wygaśnięcia</span
          >
          <p-date-picker
            (onClear)="onPrimeFilterChangeMobile($event, 'endDate')"
            (onSelect)="onPrimeFilterChangeMobile($event, 'endDate')"
            [(ngModel)]="tableFilters.endDate"
            [iconDisplay]="'input'"
            [readonlyInput]="true"
            [showClear]="true"
            [showIcon]="true"
            appendTo="body"
            ariaLabelledBy="endDateFilterMobileLabel"
            class="w-full customDatePicker"
            dateFormat="dd-mm-yy"
          />
        </div>
        <div class="flex flex-col gap-3">
          <span class="font-bold" id="recipientTypeFilterMobileLabel"
            >Typ adresatów</span
          >
          <p-select
            (onChange)="
              onPrimeFilterChangeMobile($event.value, 'recipientType')
            "
            [(ngModel)]="tableFilters.recipientType"
            [options]="recipientTypeOptions"
            [showClear]="true"
            placeholder="Wybierz wartość"
            appendTo="body"
            ariaLabelledBy="recipientTypeFilterMobileLabel"
            class="w-full"
            optionLabel="label"
            optionValue="value"
          ></p-select>
        </div>
        <div class="flex flex-col gap-2">
          <span class="font-bold" id="createdByFilterMobileLabel"
            >Utworzył</span
          >
          <input
            (input)="onPrimeFilterChangeMobile($event.target, 'createdBy')"
            [(ngModel)]="tableFilters.createdBy"
            aria-labelledby="createdByFilterMobileLabel"
            class="w-full"
            pInputText
          />
        </div>
      </div>
      <div
        class="flex w-full gap-3 justify-start mt-3 md:w-auto md:gap-2 md:justify-end"
      >
        <p-button
          (click)="clearFilters()"
          label="Wyczyść filtry"
          styleClass="customInfoButton outlined"
          type="button"
        />
        <p-button
          (onClick)="searchAnnouncements($event)"
          label="Wyszukaj"
          styleClass="customInfoButton"
          type="button"
        />
      </div>
    </p-card>

    <div class="flex flex-col gap-10">
      @for (announcement of rows(); track announcement.id) {
        <p-card>
          <div class="flex flex-col">
            <app-preview-data-wrapper
              label="Identyfikator"
              [data]="announcement.id"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Tytuł"
              [data]="announcement.title"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Status"
              [data]="announcement.status"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Data utworzenia"
              [data]="announcement.createdAt"
              [dataType]="PreviewDataType.DATE"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Data rozpoczęcia"
              [data]="announcement.startDate"
              [dataType]="PreviewDataType.DATE"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Data wygaśnięcia"
              [data]="announcement.endDate"
              [dataType]="PreviewDataType.DATE"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Typ adresatów"
              [data]="announcement.recipientType"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Utworzył"
              [data]="announcement.createdBy"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>

            <div class="flex justify-end gap-4 mt-5">
              <p-button
                label="Zobacz szczegóły"
                styleClass="customInfoButton outlined"
                (click)="showDetails(announcement)"
              />
              @if (announcement | isAnnouncementDeleteAvailable) {
                <p-button
                  label="Usuń"
                  styleClass="customInfoButton outlined"
                  (click)="openDeleteAnnouncementModal(announcement)"
                />
              }
            </div>
          </div>
        </p-card>
      }

      @if (!rows().length && !isDataLoading()) {
        <p-card>
          <div>Brak danych</div>
        </p-card>
      }
    </div>
    <p-paginator
      (onPageChange)="onPrimePageChange($event)"
      [rowsPerPageOptions]="[10, 25, 50]"
      [rows]="tablePage()?.size || 10"
      [totalRecords]="tablePage()?.totalElements"
      pageLinkSize="3"
    />
    <div
      class="flex flex-col items-start gap-3 mt-5 md:flex-row md:items-center md:justify-between"
    >
      <div class="text-sm">
        <span>
          Strona {{ (tablePage()?.number || 0) + 1 }} z
          {{ tablePage()?.totalPages || 0 }}
        </span>
      </div>
      <p-button
        (click)="addAnnouncement()"
        [text]="true"
        aria-label="Dodaj komunikat"
        label="Dodaj komunikat"
        styleClass="customInfoButton"
        type="button"
      />
    </div>
  </div>
</div>
